export default "__VITE_ASSET__4ce6f537__"